import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './dark-theme.css'; // Your custom dark theme CSS

// Import Material-UI components
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Create a dark theme configuration
const darkTheme = createTheme({
  palette: {
    mode: 'dark', // Set the theme mode to dark
    primary: {
      main: '#5B5BFF', // Customize primary color if needed
    },
    background: {
      default: '#1E1E1E', // Matches body background color
      paper: '#2D2D2D', // Matches card background color
    },
    text: {
      primary: '#D1D5DB', // Customize default text color
    },
  },
  typography: {
    fontFamily: 'Space Grotesk, open-sans', 
  },
});


// Use ReactDOM.createRoot and ThemeProvider once
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={darkTheme}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

